<template>
  <v-btn icon @click="toggleDrawer">
    <v-icon :color="color">{{ icon }}</v-icon>
  </v-btn>
</template>

<script>
import { TOGGLE_DRAWER } from "../action-types";

export default {
  name: "AppDrawerToggleButton",
  props: {
    color: {
      type: String,
      default: undefined
    },
    icon: {
      type: String,
      default: "fa fa-bars"
    }
  },
  methods: {
    toggleDrawer() {
      this.$store.dispatch(TOGGLE_DRAWER);
    }
  }
};
</script>
